import { Component, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { PetInsuranceData } from "../../models";
import { DataStorageService } from "../../services/data-storage.service";
import { EditPetInfoComponent } from "../../modules/insurance/edit-pet-info/edit-pet-info.component";
import { Observable, Subject, takeUntil } from "rxjs";

@Component({
  selector: 'cpf-edit-pet-info-page',
  templateUrl: './edit-pet-info-page.component.html',
  styleUrls: ['./edit-pet-info-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditPetInfoPageComponent implements OnDestroy {
  @ViewChild(EditPetInfoComponent) editPetInfoComponent?: EditPetInfoComponent;

  petData?: PetInsuranceData;
  private destroy$ = new Subject<void>();

  constructor(private dataStorageService: DataStorageService) {
    this.setPetData();

    this.dataStorageService.selectedData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (data) {
        this.petData = data;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setPetData() {
    const selectedData = this.dataStorageService.selectedData;

    if (selectedData) {
      this.petData = selectedData;
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.editPetInfoComponent?.canDeactivate() ?? true;
  }
}
